export function prepareAndDownloadCSV(sales, label) {
    const headers = label === "sales" ? [
        "Sale ID",
        "Customer Name",
        "Total Amount",
        "Date",
        "Products",
        "Payment Methods",
    ] : [
        "Sale ID",
        "Customer Name",
        "Total Amount",
        "Date",
        "Products",
    ];

    const rows = sales?.map((sale) => {
        const customerName = sale?.customer?.name || "N/A";
        const products = [
            ...sale?.products?.map((product) => product?.name),
        ].join(", ");
        const paymentMethods = sale?.sale_payment_methods
            ?.map((method) => method?.label)
            .join(", ");

        const saleId = `${sale?.id} ${sale?.deleted_at ? 'deleted' : ''}`

        if(label === 'sales'){
            return [
                saleId,
                customerName,
                sale.total_amount,
                sale.date,
                products,
                paymentMethods,
            ];
        }else{
            return [
                saleId,
                customerName,
                sale.total_amount,
                sale.date,
                products,
            ];
        }

    });

    const csvContent =
        [headers.join(",")]
            .concat(rows?.map((row) => row.map((cell) => `"${cell}"`).join(",")))
            .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    return blob;
}